import Ads from './AdsRequests'
import Agency from './AgencyRequests'
import Marketing from './MarketingRequests'
import Brands from './BrandsRequests'
import Screenshots from './ScreenshotsRequests'
import Search from './SearchRequests'
import Users from './UsersRequests'
import Campaigns from './CampaignRequests'
import Briefs from './BriefsRequests'
import Subscription from './SubscriptionRequests'
import PublicAPI from './PublicAPIRequests'
import Teams from './TeamRequests'
import Spyder from './SpyderRequests'
import Boards from './BoardRequests'
export default {
  Ads,
  Agency,
  Marketing,
  Brands,
  Screenshots,
  Search,
  Users,
  Campaigns,
  Briefs,
  Subscription,
  PublicAPI,
  Teams,
  Spyder,
  Boards
}